import React from 'react'

import style from './FeedbackMessage.module.css'

import { ReactComponent as WomanShruggingIcon } from 'assets/icons/woman-shrugging.svg'
import { useAppSelector } from 'common/hooks'
import { selectCurrentResult, selectCurrentTask } from 'features/exam'

export const FeedbackMessage = () => {
  const currentTask = useAppSelector(selectCurrentTask)
  const rightAnswersId = currentTask.answers
    .filter(answer => answer.isCorrect)
    .map(answer => answer.id)

  const currentResult = useAppSelector(selectCurrentResult)

  const createFeedbackMessage = () => {
    let feedbackMessage

    if (currentResult.status === null) {
      feedbackMessage = ''
    } else if (currentResult.status) {
      feedbackMessage = 'Верно! 👌'
    } else if (currentResult.answers.every(answerId => rightAnswersId.includes(answerId))) {
      feedbackMessage = (
        <>
          Ответ неполный 😶
          <Message />
        </>
      )
    } else {
      feedbackMessage = (
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'end',
              gap: '5px',
            }}
          >
            Похоже на ошибку
            <WomanShruggingIcon width="30" height="30" />
          </div>
          <Message />
        </>
      )
    }

    return feedbackMessage
  }

  return <div>{createFeedbackMessage()}</div>
}

export const Message = () => {
  return (
    <p className={style.issue}>
      Если в вопросе что-то не так, можно отправить&nbsp;
      <a
        className={style.link}
        href="https://github.com/it-incubator/interview-questions-db/issues"
        target="_blank"
        rel="noreferrer"
      >
        issue
      </a>{' '}
      или{' '}
      <a
        className={style.link}
        href="https://github.com/it-incubator/interview-questions-db/pulls"
        target="_blank"
        rel="noreferrer"
      >
        pull&nbsp;request
      </a>
    </p>
  )
}
